var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.editVue}},[_vm._v("编辑")]),_c('el-button',{on:{"click":_vm.exportVue}},[_vm._v("导出")]),_c('el-button',{on:{"click":_vm.openScript}},[_vm._v("外部资源")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }